enum TextPageType {
  PRODUCTS_RETURN,
  PERSONAL_DETAILS,
  TERMS,
  FAQ
}

export default TextPageType;